import { useVariantGroupApi } from "@/hooks/apiHooks/useVariantGroupApi";
import type { VariantGroupResponse } from "@/models/variantGroup";
import Button from "@common/Button";
import { useState } from "react";

export const ExampleVariantGroup = () => {
    const {
        getAllVariantGroups,
        getVariantGroup,
        createVariantGroup,
        updateVariantGroup,
        deleteVariantGroup,
    } = useVariantGroupApi();

    const [variantGroups, setVariantGroups] = useState<VariantGroupResponse[]>(
        []
    );

    const fetchVariantGroups = async () => {
        const result = await getAllVariantGroups();

        setVariantGroups(result);
    };

    const handleGetAll = async () => {
        await fetchVariantGroups();
    }

    const handleCreate = async () => {
        await createVariantGroup({ name: Date.now().toString() });

        await fetchVariantGroups();
    };

    const handleGet = async (id: number) => {
        const group = await getVariantGroup(id);

        console.log("Variant group fetched:", group);
    };

    const handleUpdate = async (id: number) => {
        await updateVariantGroup(id, { name: Date.now().toString() });

        await fetchVariantGroups();
    };

    const handleDelete = async (id: number) => {
        await deleteVariantGroup(id);

        await fetchVariantGroups();
    };

    return (
        <div>
            <Button onClick={handleGetAll}>Get All</Button>
            <Button onClick={handleCreate}>Create New Variant Group</Button>

            <div>Variant Groups List ({variantGroups.length})</div>

            <ul>
                {variantGroups.map((group) => (
                    <li key={group.id}>
                        <div>
                            <p>ID: {group.id}</p>
                            <p>Name: {group.name}</p>
                        </div>

                        <div>
                            <Button onClick={() => handleGet(group.id)}>
                                Get
                            </Button>
                            <Button onClick={() => handleUpdate(group.id)}>
                                Update
                            </Button>
                            <Button onClick={() => handleDelete(group.id)}>
                                Delete
                            </Button>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
};
